export const icons = {};

export class IconCache {
    static setIcon(key, icon) {
        this.cache.set(key, icon);
    }
    static getIcon(key) {
        return this.cache.has(key) ? this.cache.get(key) : null;
    }
    static hasIcon(key) {
        return this.cache.has(key);
    }
    static clear(key) {
        return this.cache.delete(key);
    }
    static clearAll() {
        this.cache = new Map;
    }
}

IconCache.cache = new Map;
//# sourceMappingURL=icons.js.map
